<template>
  <div class="container-activity-detail">
    <MpNavbar />
    <MpTitle
      v-if="activityData"
      :title="'杯测结果详表：' + activityData.title"
      :intro="
        '杯测表：' +
        activityData.table.name +
        ' | 本次杯测共' +
        activityData.tableData.length +
        '个咖啡豆 | ' +
        (activityData.desc || '无活动介绍')
      "
    />
    <div class="content-table" id="content-table">
      <!-- height="300" :loading="loading" -->
      <vxe-toolbar>
        <template #buttons>
          <vxe-button @click="reflash">刷新</vxe-button>
          <vxe-button @click="exportDataEvent">导出.xlsx表格</vxe-button>
          <vxe-button @click="printEvent">打印</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-grid
        ref="xTable"
        v-bind="gridOptions"
        class="custom-table"
      ></vxe-grid>
    </div>
  </div>
</template>

<script>
import MpNavbar from "../../components/mp/navbar";
import MpTitle from "../../components/mp/title";
import { apiActivityDetail } from "../../request/api";

export default {
  components: {
    MpNavbar,
    MpTitle,
  },
  name: "activityDetail",
  // props: {
  //   msg: String
  // },
  data() {
    return {
      uuid: null,
      activityData: null,
      // rowClassName: ,
      tablePrint: {},
      gridOptions: {
        border: true,
        height: null,
        loading: false,
        highlightCurrentRow: true,
        rowClassName: this.rowClassName,
        cellClassName: this.cellClassName,
        align: "left",
        mergeCells: null,
        columns: null,
        data: null,
      },
    };
  },
  mounted() {
    this.init();
    window.onresize = () => {
      this.setTableHeight();
    };
  },
  methods: {
    init() {
      this.uuid = this.$route.params.uuid;
      this.getDetail();
      this.setTableHeight();
    },
    setTableHeight() {
      var h = document.body.clientHeight - 50 - 69 - 60;
      this.gridOptions.height = h;
    },
    reflash() {
      this.gridOptions.mergeCells = null;
      this.gridOptions.columns = null;
      this.gridOptions.data = null;
      this.getDetail();
    },
    getDetail() {
      this.gridOptions.loading = true;
      let self = this;
      apiActivityDetail({
        uuid: self.uuid,
      })
        .then((res) => {
          self.activityData = res.data;
          self.readyData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    readyData(resData) {
      let data = resData.tableData;
      // 1- 拆豆子
      let dataA = [];
      for (let index = 0; index < data.length; index++) {
        for (let index2 = 0; index2 < data[index].users.length; index2++) {
          let obj = data[index].users[index2];
          obj.beanInfo = data[index].beanInfo;
          obj.beanUuid = data[index].beanUuid;
          obj.beanIndex = index;
          dataA.push(obj);
        }
      }
      // 2-拆杯测记录
      let dataB = [];
      for (let index = 0; index < dataA.length; index++) {
        let obj = { ...dataA[index].data };
        obj = Object.assign(dataA[index], obj);
        dataB.push(obj);
      }

      // 3-整合数据列标题
      //获取table杯测表基础数据
      let columnsA = [
        { type: "seq", width: 50 },
        { field: "beanInfo.name", title: "咖啡豆", width: 100 },
        { field: "userInfo.nickname", title: "杯测人", width: 100 },
        {
          field: "status",
          title: "是否完成",
          formatter: this.formatStatus,
          width: 80,
        },
        {
          field: "fav",
          title: "收藏",
          formatter: this.formatFav,
          width: 70,
          align: "center",
        },
      ];
      let columnsB = [];
      let columnsC = [
        {
          field: "score",
          title: "总分",
          formatter: this.formatScore,
          align: "center",
          width: 70,
        },
        { field: "remarks", title: "备注", width: 150 },
      ];

      let tableForm = resData.table.form;
      // 计算列
      for (let index = 0; index < tableForm.length; index++) {
        let type = tableForm[index].type;
        let ary = []; // 在这里初始化 ary

        if (type == "p_n") {
          // 组件 - 正负面评价
          ary = [
            {
              field: index + "." + "value.positive",
              title: tableForm[index].name + "(正面)",
              width: 100,
            },
            {
              field: index + "." + "value.negative",
              title: tableForm[index].name + "(负面)",
              width: 100,
            },
          ];
        } else if (
          type == "scroll_desc" ||
          type == "scroll_array_desc" ||
          type == "select_score_desc"
        ) {
          // 组件 - 滑块和描述
          ary = [
            {
              field: index + "." + "value.score",
              title: tableForm[index].name + "(打分)",
              width: 100,
              align: "right",
            },
            {
              field: index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "unicup_desc") {
          // 组件 - 一致性评测组件
          ary = [
            {
              field: index + "." + "value.cups",
              title: tableForm[index].name + "(打分)",
              width: 100,
              formatter: this.formatUnicup,
            },
            {
              field: index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "boolean_desc") {
          // Todo 选择Yes/No组件
          ary = [
            {
              field: index + "." + "value.boolean",
              title: tableForm[index].name + "(打分)",
              width: 100,
            },
            {
              field: index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "defects_desc") {
          // 组件 - 瑕疵记录组件
          ary = [
            {
              field: index + "." + "value.cups",
              title: tableForm[index].name + "(杯数)",
              width: 100,
            },
            {
              field: index + "." + "value.intensity",
              title: tableForm[index].name + "(严重程度)",
              width: 100,
            },
            {
              field: index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "select_lite_desc") {
          // 组件 - 小型单选组件
          ary = [
            {
              field: index + "." + "value.select",
              title: tableForm[index].name,
              width: 100,
            },
            {
              field: index + "." + "value.desc",
              title: tableForm[index].name + "(描述)",
              width: 100,
            },
          ];
        } else if (type == "desc") {
          // 组件 - 单文本输入组件
          ary = [
            {
              field: index + "." + "value.desc",
              title: tableForm[index].name,
              width: 100,
            },
          ];
        } else if (type == "min_title") {
          // 组件 - 分隔小标题
          ary = [];
        } else if (type == "select_score_select_multiple") {
          // 组件 - 多选打分组件
          ary = [
            {
              field: index + "." + "value.score",
              title: tableForm[index].name + "(打分)",
              width: 100,
            },
            {
              field: index + "." + "value.select",
              title: tableForm[index].name + "(选择)",
              width: 100,
            },
          ];
        } else if (type == "select_multiple") {
          // 组件 - 多选组件
          ary = [
            {
              field: index + "." + "value.select",
              title: tableForm[index].name + "(选择)",
              width: 100,
            },
          ];
        } else {
          // 未知组件
          ary = [];
        }
        columnsB = [...columnsB, ...ary];
      }

      // 保存原始数据和列定义
      const originalColumns = [...columnsA, ...columnsB, ...columnsC];
      const originalData = dataB;

      // 转置处理函数
      const transposeTableData = (data, columns) => {
        // 创建新的列定义
        let newColumns = [
          { type: "seq", width: 50, title: "序号" },
          { field: "field", title: "评测项", width: 150 },
        ];

        // 为每条数据创建一个列
        data.forEach((item, index) => {
          newColumns.push({
            field: "value_" + index,
            title: `${item.beanInfo?.name || ""} - ${
              item.userInfo?.nickname || ""
            }`,
            width: 120,
          });
        });

        // 创建转置后的数据
        let newData = [];

        // 处理每个原始列
        columns.forEach((col) => {
          if (col.type === "seq") return;

          let rowData = {
            field: col.title,
          };

          // 填充每行的值
          data.forEach((item, index) => {
            let value = "";
            if (col.field === "beanInfo.name") {
              value = item.beanInfo?.name;
            } else if (col.field === "userInfo.nickname") {
              value = item.userInfo?.nickname;
            } else if (col.field === "status") {
              value = this.formatStatus(item.status);
            } else if (col.field === "fav") {
              value = this.formatFav(item.fav);
            } else if (col.field === "score") {
              value = this.formatScore(item.score);
            } else if (col.field === "remarks") {
              value = item.remarks;
            } else {
              // 处理动态表单字段
              try {
                let fieldPath = col.field.split(".");
                let obj = item;
                for (let path of fieldPath) {
                  obj = obj?.[path];
                }
                value = obj;
              } catch (error) {
                value = "";
              }
            }
            rowData["value_" + index] = value;
          });

          newData.push(rowData);
        });

        return {
          columns: newColumns,
          data: newData,
        };
      };

      // 执行转置处理
      const transposedResult = transposeTableData.call(
        this,
        originalData,
        originalColumns
      );

      // 更新表格配置
      this.gridOptions.columns = transposedResult.columns;
      this.gridOptions.data = transposedResult.data;
      this.gridOptions.loading = false;
    },
    formatFav({ cellValue, row, column }) {
      if (cellValue == 2) {
        return "⭐ 已收藏"; // 使用星星emoji
      } else {
        return "☆ 未收藏"; // 空心星星表示未收藏
      }
    },

    formatStatus({ cellValue, row, column }) {
      if (cellValue == 3) {
        return "✅ 已提交"; // 使用对勾emoji
      } else {
        return "❌ 未提交"; // 使用叉号emoji
      }
    },
    formatUnicup({ cellValue, row, column }) {
      if (cellValue) {
        let result = "";
        for (let index = 0; index < cellValue.length; index++) {
          if (cellValue[index] == 1) {
            result = result + "×";
          } else {
            result = result + "□";
          }
        }
        return result;
      } else {
        return "";
      }
    },
    formatScore({ cellValue, row, column }) {
      if (cellValue == 0) {
        return "无分数";
      } else {
        return cellValue;
      }
    },
    exportDataEvent() {
      let self = this;
      this.$refs.xTable.exportData({
        filename: "【杯测结果详表】" + self.activityData.title,
        sheetName: "Sheet1",
        type: "xlsx",
      });
    },
    rowClassName({ row, rowIndex }) {
      if (row.beanIndex % 2 != 0) {
        //偶数
        return "activity-detail-row-gray";
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      // 未提交
      if (column.property === "status") {
        if (row.status != 3) {
          return "activity-detail-cell-red";
        }
      }
      // 已经收藏
      if (column.property === "fav") {
        if (row.fav == 2) {
          return "activity-detail-cell-fav";
        }
      }
      if (column.property === "score") {
        if (row.score > 0) {
          return "activity-detail-cell-bold";
        } else {
          return "activity-detail-cell-gray";
        }
      }
    },
    printEvent() {
      this.$refs.xTable.print({
        sheetName: this.activityData.title + "- GiiLoo 咖啡杯测",
      });
      // const divEl = document.getElementById('print')
      // this.$XPrint({
      //   sheetName: '打印下面区域',
      //   content: divEl.innerHTML
      // })
    },
  },
};
</script>

<style scoped>
.container-activity-detail {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  padding-left: 110px;
  padding-top: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
}

.content-table {
  flex: 1;
  height: 200px;
  margin: 0;
}
</style>
<style>
.activity-detail-row-gray {
  background-color: #fafafa;
  /* color: #fff; */
}

/* 为表格添加自定义样式 */
.custom-table {
  background-color: #ffffff;
}

/* 确保表格的每一行都是白色背景 */
.custom-table .vxe-body--row {
  background-color: #ffffff !important;
}

.min_title {
  /* background-color: #eee; */
  font-weight: bold;
}

.activity-detail-cell-red {
  color: #fd4343;
}

.activity-detail-cell-fav {
  font-size: 20px;
  color: #ffd685;
}

.activity-detail-cell-bold {
  font-size: 18px;
  font-weight: bold;
}

.activity-detail-cell-gray {
  color: #ccc;
}
</style>
